module.exports = __webpack_public_path__ + "img/main2.b396578f.png";